import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'store/main';

const userSelector = (state: RootState): RootState['user'] => state.user;

// Plain field reads. Wrapping them in `createSelector` memoizes nothing and trips reselect's
// identity-function check, since the result function hands back the input untouched.
export const getCurrentUser = userSelector;

export const getUserId = createSelector(userSelector, (user): string => user.id);

export const getInviteData = createSelector(
  userSelector,
  (user): { advisorName: string; firmName: string } => user.inviteData,
);
